<template>
	<div class="card mb-3">
		<div class="card-body">
			<h5 class="card-title">
				{{ localAchievement._id ? "Edit Achievement" : "Create Achievement" }}
			</h5>
			<form @submit.prevent="save">
				<div class="mb-3">
					<label class="form-label">Title</label>
					<input
						type="text"
						class="form-control"
						v-model="localAchievement.name"
						required />
				</div>
				<div class="mb-3">
					<label class="form-label">Description</label>
					<textarea
						class="form-control"
						v-model="localAchievement.description"
						required></textarea>
				</div>
				<div class="mb-3">
					<label class="form-label">Valid From</label>
					<input
						type="date"
						class="form-control"
						v-model="localAchievement.validFrom" />
				</div>
				<div class="mb-3">
					<label class="form-label">Valid To</label>
					<input
						type="date"
						class="form-control"
						v-model="localAchievement.validTo" />
				</div>
				<div class="mb-3">
					<label class="form-label">Criteria</label>
					<div
						v-for="(criterion, index) in localAchievement.criteria"
						:key="index"
						class="border p-3 mb-2">
						<div class="mb-2">
							<label class="form-label">Type</label>
							<select class="form-control" v-model="criterion.type">
								<option value="log_activity">Log Activity</option>
								<option value="log_food">Log Food</option>
								<option value="log_drink">Log Drink</option>
								<option value="log_water">Log Water</option>
								<option value="log_streak">Log Streak</option>
								<option value="log_weight">Log Weight</option>
								<option value="log_blood_sugar">Log Blood Sugar</option>
							</select>
						</div>
						<div class="mb-2">
							<label class="form-label">Field</label>
							<select class="form-control" v-model="criterion.field">
								<template
									v-if="
										criterion.type !== 'log_streak' &&
										criterion.type !== 'log_activity'
									">
									<option value="mealType">Meal Type</option>
									<option value="amount">Amount</option>
									<option value="rating">Rating</option>
									<option value="food_category">Food Category</option>
									<option value="nutritionalInfo.protein">Protein</option>
									<option value="nutritionalInfo.fat">Fat</option>
									<option value="nutritionalInfo.carbs">Carbohydrates</option>
									<option value="nutritionalInfo.calories">Calories</option>
									<option value="nutritionalInfo.sugar">Sugar</option>
									<option value="nutritionalInfo.fiber">Fiber</option>
									<option value="nutritionalInfo.sodium">Sodium</option>
									<option value="weight">Weight</option>
									<option value="bloodSugar">Blood Sugar</option>
								</template>
								<template v-else>
									<option value="log_food">Log Food</option>
									<option value="log_drink">Log Drink</option>
									<option value="log_water">Log Water</option>
									<option value="log_weight">Log Weight</option>
									<option value="log_blood_sugar">Log Blood Sugar</option>
								</template>
							</select>
						</div>
						<div class="mb-2">
							<label class="form-label">Operator</label>
							<select class="form-control" v-model="criterion.operator">
								<option value="equals">Equals</option>
								<option value="not_equals">Not Equals</option>
								<option value="greater_than">Greater Than</option>
								<option value="greater_than_or_equal">
									Greater Than Or Equal
								</option>
								<option value="less_than">Less Than</option>
								<option value="less_than_or_equal">Less Than Or Equal</option>
								<option value="contains">Contains</option>
								<option value="increase">Increase</option>
								<option value="increase_by">Increase By</option>
								<option value="decrease">Decrease</option>
								<option value="decrease_by">Decrease By</option>
							</select>
						</div>
						<div class="mb-2">
							<label class="form-label">Value</label>
							<input
								type="text"
								class="form-control"
								v-model="criterion.value" />
						</div>
						<div class="mb-2">
							<label class="form-label">Timeframe (Days)</label>
							<input
								type="number"
								class="form-control"
								v-model="criterion.timeframe" />
						</div>
						<button
							type="button"
							class="btn btn-danger"
							@click="removeCriterion(index)">
							Remove
						</button>
					</div>
					<button type="button" class="btn btn-primary" @click="addCriterion">
						Add Criterion
					</button>
				</div>
				<div class="mb-3">
					<label class="form-label">Aggregate</label>
					<div v-if="localAchievement.aggregate" class="border p-3 mb-2">
						<div class="mb-2">
							<label class="form-label">Aggregate Type</label>
							<select
								class="form-control"
								v-model="localAchievement.aggregate.type">
								<option value="count">Count</option>
								<option value="sum">Sum</option>
								<option value="streak">Streak</option>
							</select>
						</div>
						<div class="mb-2">
							<label class="form-label">Field</label>
							<select
								class="form-control"
								v-model="localAchievement.aggregate.field">
								<option value="mealType">Meal Type</option>
								<option value="amount">Amount</option>
								<option value="rating">Rating</option>
								<option value="nutritionalInfo.protein">Protein</option>
								<option value="nutritionalInfo.fat">Fat</option>
								<option value="nutritionalInfo.carbs">Carbohydrates</option>
								<option value="nutritionalInfo.calories">Calories</option>
								<option value="nutritionalInfo.sugar">Sugar</option>
								<option value="nutritionalInfo.fiber">Fiber</option>
								<option value="nutritionalInfo.sodium">Sodium</option>
								<option value="weight">Weight</option>
								<option value="bloodSugar">Blood Sugar</option>
							</select>
						</div>
						<div class="mb-2">
							<label class="form-label">Operator</label>
							<select
								class="form-control"
								v-model="localAchievement.aggregate.operator">
								<option value="equals">Equals</option>
								<option value="not_equals">Not Equals</option>
								<option value="greater_than">Greater Than</option>
								<option value="greater_than_or_equal">
									Greater Than Or Equal
								</option>
								<option value="less_than">Less Than</option>
								<option value="less_than_or_equal">Less Than Or Equal</option>
								<option value="contains">Contains</option>
								<!-- <option value="increase">Increase</option>
								<option value="increase_by">Increase By</option>
								<option value="decrease">Decrease</option>
								<option value="decrease_by">Decrease By</option> -->
							</select>
						</div>
						<div class="mb-2">
							<label class="form-label">Value</label>
							<input
								type="number"
								class="form-control"
								v-model="localAchievement.aggregate.value" />
						</div>
						<div class="mb-2">
							<label class="form-label">Timeframe (Days)</label>
							<input
								type="number"
								class="form-control"
								v-model="localAchievement.aggregate.timeframe" />
						</div>
						<button
							type="button"
							class="btn btn-danger"
							@click="removeAggregate">
							Remove
						</button>
					</div>
					<div v-else>
						<button type="button" class="btn btn-primary" @click="addAggregate">
							Add Aggregate
						</button>
					</div>
				</div>
				<div class="mb-3">
					<label class="form-label">Icon URL</label>
					<div class="input-group">
						<input
							type="text"
							class="form-control"
							v-model="localAchievement.imageUrl"
							readonly />
						<button
							type="button"
							class="btn btn-outline-secondary"
							@click="generateIcon">
							Generate Icon
						</button>
					</div>
				</div>
				<button type="submit" class="btn btn-primary">
					{{ localAchievement._id ? "Save Changes" : "Create Achievement" }}
				</button>
				<button type="button" class="btn btn-secondary" @click="cancel">
					Cancel
				</button>
			</form>
		</div>
	</div>
</template>

<script setup>
	import { reactive, watch } from "vue"
	// import { hasTokenIssue, handleTokenIssue } from "@/utils/tokenIssue"
	import { fetchWithAuth } from "@/utils/api-client"
	import { useTokenStore } from "@/stores/token"

	const tokenStore = useTokenStore()

	const props = defineProps({
		achievement: {
			type: Object,
			required: true,
		},
	})

	const emit = defineEmits(["save", "cancel"])

	const localAchievement = reactive({
		...props.achievement,
		criteria: props.achievement.criteria ? [...props.achievement.criteria] : [],
		aggregate: props.achievement.aggregate
			? { ...props.achievement.aggregate }
			: null,
	})

	watch(props.achievement, (newVal) => {
		Object.assign(localAchievement, {
			...newVal,
			criteria: newVal.criteria ? [...newVal.criteria] : [],
			aggregate: newVal.aggregate ? { ...newVal.aggregate } : null,
		})
	})

	const save = () => {
		emit("save", localAchievement)
	}

	const generateIcon = async () => {
		// localAchievement.imageUrl = "https://via.placeholder.com/150"
		try {
			const response = await fetchWithAuth("/api/achievements/genIcon", {
				method: "POST",
				// headers: {
				// 	Authorization: `Bearer ${tokenStore.token}`,
				// },
				body: JSON.stringify({
					title: localAchievement.name,
					description: localAchievement.description,
				}),
			})
			// if (hasTokenIssue(response)) {
			// 	handleTokenIssue(response)
			// } else {
			const data = await response.json()
			localAchievement.imageUrl = data.key
			// }
		} catch (e) {
			console.log(e)
			localAchievement.imageUrl = "https://via.placeholder.com/150"
		}
	}

	const addCriterion = () => {
		localAchievement.criteria.push({
			type: "",
			field: "",
			operator: "",
			value: "",
			timeframe: null,
		})
	}

	const removeCriterion = (index) => {
		localAchievement.criteria.splice(index, 1)
	}

	const addAggregate = () => {
		localAchievement.aggregate = {
			type: "",
			field: "",
			operator: "",
			value: "",
			timeframe: null,
		}
	}

	const removeAggregate = () => {
		localAchievement.aggregate = null
	}

	const cancel = () => {
		emit("cancel")
	}
</script>
